import React from 'react';
import { Link } from 'react-router';

import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add';


const style = {
    position: 'fixed',
    right: '24px',
    bottom: '24px',
    zIndex: 1000,
};

const AddEntityButton = (props) => (

    <Link to={props.newEntityUrl}>
        <FloatingActionButton style={style} >
            <ContentAddIcon />
            </FloatingActionButton>
        </Link>

);

export default AddEntityButton;
